const topAlertActionTypes = {
  SHOW_TOP_ALERT: 'SHOW_TOP_ALERT',
  HIDE_TOP_ALERT: 'HIDE_TOP_ALERT',
};
export default topAlertActionTypes;
